import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=6a812608&scoped=true&"
import script from "./productDetails.vue?vue&type=script&lang=js&"
export * from "./productDetails.vue?vue&type=script&lang=js&"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=6a812608&prod&scoped=true&lang=css&"
import style1 from "./productDetails.vue?vue&type=style&index=1&id=6a812608&prod&scoped=true&lang=scss&"
import style2 from "./productDetails.vue?vue&type=style&index=2&id=6a812608&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a812608",
  null
  
)

export default component.exports